import {NgModule} from '@angular/core';
import {AppImageComponent} from "../../components/app-image/app-image.component";
import {CommonModule, NgOptimizedImage} from "@angular/common";
import {UnwrapTagDirective} from "../../directives/unwrap-tag/unwrap-tag.directive";
import {ExternalLinkDirective} from "../../directives/external-link/external-link.directive";
import {DomainPipe} from "../../pipes/domain.pipe";
import {CountryFlagPipe} from "../../pipes/country-flag.pipe";
import {TypeaheadComponent} from "../../components/typeahead/typeahead.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NgbTypeahead} from "@ng-bootstrap/ng-bootstrap";
import {TagsInputComponent} from "../../components/tags-input/tags-input.component";
import {SafeHtmlPipe} from "../../pipes/safe-html.pipe";
import {SafeUrlPipe} from "../../pipes/safe-url.pipe";
import {IsNewPipe} from "../../pipes/is-new.pipe";
import {LiveSearchSelectModule} from "../../components/live-search-select/live-search-select.module";
import {ListNavigationComponent} from "../../components/list-navigation/list-navigation.component";
import {DropzoneComponent} from "../../components/dropzone/dropzone.component";
import {IconComponent} from "../../components/icon/icon.component";
import {AsyncJobProgressComponent} from "../../components/async-job-progress/async-job-progress.component";
import {NewBadgeComponent} from "../../components/new-badge/new-badge.component";
import {HexagonLogoComponent} from "../../components/hexagon-logo/hexagon-logo.component";
import {ToastCardComponent} from "../../components/toast-card/toast-card.component";
import {AdminAvatarComponent} from "../../components/admin-avatar/admin-avatar.component";

@NgModule({
    declarations: [
        AppImageComponent,
        DropzoneComponent,
        TypeaheadComponent,
        TagsInputComponent,
        ListNavigationComponent,
        IconComponent,
        AsyncJobProgressComponent,
        NewBadgeComponent,
        HexagonLogoComponent,
        ToastCardComponent,
        AdminAvatarComponent,
        UnwrapTagDirective,
        ExternalLinkDirective,
        DomainPipe,
        CountryFlagPipe,
        SafeUrlPipe,
        SafeHtmlPipe,
        IsNewPipe,
    ],
    exports: [
        AppImageComponent,
        DropzoneComponent,
        TypeaheadComponent,
        TagsInputComponent,
        ListNavigationComponent,
        IconComponent,
        AsyncJobProgressComponent,
        NewBadgeComponent,
        HexagonLogoComponent,
        ToastCardComponent,
        AdminAvatarComponent,
        UnwrapTagDirective,
        ExternalLinkDirective,
        DomainPipe,
        CountryFlagPipe,
        SafeUrlPipe,
        SafeHtmlPipe,
        IsNewPipe,
    ],
    imports: [
        NgOptimizedImage,
        CommonModule,
        FormsModule,
        NgbTypeahead,
        ReactiveFormsModule,
        LiveSearchSelectModule,
    ],
    // Export the component to make it accessible by other modules
})
export class SharedModule {
}